import { themeReducer } from './theme';
import { authReducer } from './auth';
import { campaignReducer } from './campaign';
import { referralReducer } from "./referral";

export const reducer = (
  { 
    theme, auth, campaign, referral
  },
  action,
) => ({
  theme: themeReducer(theme, action),
  auth: authReducer(auth, action),
  campaign: campaignReducer(campaign, action),
  referral: referralReducer(referral, action),
});
